module.exports = __webpack_public_path__ + "img/gala-journey.7d21a5ff.svg";